<template>
  <div :class="'custom_input '+width">
    <div class="label">
      {{ capitalisedLabel }}
    </div>
    <div class="custom_color_picker">
      <div class="selected_colors">
        <span v-if="modelValue && modelValue.length === 0">No colors selected - Please add colors</span>
        <span
          v-for="(colorOption, index) in modelValue"
          :key="index"
          :style="'background: '+colorOption+'; color: '+textColor(colorOption)+';'"
          class="color-tag"
        >
          {{ colorOption }}
          <span
            class="multiselect-tag-remove"
            @click="removeColor(index)"
          >
            <span class="multiselect-tag-remove-icon" />
          </span>
        </span>
      </div>

      <button
        :class="'btn secondary_btn add_color_btn'"
        @click="openColorPicker = true"
      >
        <span>Add Color</span>
        <color-picker
          v-if="openColorPicker"
          v-model="color"
          :include-input="true"
          position="above"
          @add="addColor()"
          @close="openColorPicker = false"
        />
      </button>
    </div>
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation"
    >{{ error }}</small>
  </div>
</template>

<script>
import _ from 'lodash';
import ColorPicker from './ColorPicker.vue';

export default {
  components: {
    ColorPicker
  },
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: Array,
      default: null
    },
    width: {
      type: String,
      required: false,
      default: 'full'
    },
    validationErrors: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      color: '#37B2A8',
      openColorPicker: false
    }
  },
  computed: {
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    }
  },
  methods: {
    textColor(color) {
      const rgb = this.hexToRgb(color);
      const brightness = Math.round(((parseInt(rgb[0]) * 299) + (parseInt(rgb[1]) * 587) + (parseInt(rgb[2]) * 114)) / 1000);
      return (brightness > 150) ? 'black' : 'white';
    },
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : null;
    },
    selectColor() {
      document.getElementById('color-picker').click();
    },
    addColor() {
      // eslint-disable-next-line vue/no-mutating-props
      this.modelValue.push(this.color);
      this.$nextTick(() => {
        this.updateValue();
      })
    },
    removeColor(index) {
      // eslint-disable-next-line vue/no-mutating-props
      this.modelValue.splice(index, 1);
      this.$nextTick(() => {
        this.updateValue();
      })
    },
    updateValue() {
      this.$emit('update:modelValue', this.modelValue);
    }
  }
}

</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.custom_input {
  margin-bottom: 1.5rem;
  color: #4E4E54;
}

.label {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.custom_color_picker {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.reporting_section .btn span {
  margin: 0;
}

.selected_colors {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 75%;
}

.selected_colors > span {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
  padding: 0 5px;
}

.color-tag {
  width: max-content;
  height: max-content;
  color: var(--tag-color, #fff);
  font-size: .875rem;
  line-height: 1.25rem;
  font-weight: 600;
  padding: .125rem 0 .125rem .5rem;
  border-radius: 4px;
  margin-right: .25rem;
  margin-bottom: .25rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.add_color_btn {
  position: relative;
  margin: 0;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}
</style>
